export default {
    appTechnicians: [],
    activeTech: {},
    manageTechDialog: false,
    deleteTechDialog: false
}
